import React from 'react'
import './Tags.scss'

export function Tag({ tag }) {
  return <span className="blog-tag">{tag}</span>
}

export function TagList({ tags }) {
  return (
    <span className="horizontal-spacing-small">
      {tags.map((tag, index) => (
        <Tag key={index} tag={tag} />
      ))}
    </span>
  )
}
